import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

type CustomSearchProductState = Readonly<{
    isNotProductFound: boolean;
}>;

const initialCustomSearchProductState: CustomSearchProductState = {
    isNotProductFound: false,
};

const reducer = {
    "xCustomSearchProduct/isNotProductFound": (draft: Draft<CustomSearchProductState>, action: { isNotProductFound: boolean }) => {
        draft.isNotProductFound = action.isNotProductFound;
    },
};

const xCustomSearchProduct = createTypedReducerWithImmer(initialCustomSearchProductState, reducer);

(reducers as any).xCustomSearchProduct = xCustomSearchProduct;

export type xCustomSearchProductState = {
    xCustomSearchProduct: CustomSearchProductState;
};

type xCustomSearchProductReducers = {
    isNotProductFound: typeof xCustomSearchProduct;
};

export type xCustomSearchProductActions = Parameters<xCustomSearchProductReducers[keyof xCustomSearchProductReducers]>[1] | AnyAction;
